import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Dialog, DialogContent } from '../ui/dialog'
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from '../ui/command'
import {
  LayoutDashboard, Users, Trophy, DollarSign, MessageCircle,
  Mail, Settings2, BarChart3, FileText, CreditCard, Search
} from 'lucide-react'

const pages = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard, description: 'Overview & metrics' },
  { name: 'Users', href: '/users', icon: Users, description: 'Manage users' },
  { name: 'Teams', href: '/teams', icon: Trophy, description: 'Manage teams' },
  { name: 'Financials', href: '/payments', icon: DollarSign, description: 'Revenue & payments' },
  { name: 'Subscriptions', href: '/subscriptions', icon: CreditCard, description: 'Plan management' },
  { name: 'Invoices', href: '/invoices', icon: FileText, description: 'Invoice history' },
  { name: 'Support', href: '/support', icon: MessageCircle, description: 'Support tickets' },
  { name: 'Communications', href: '/communications', icon: Mail, description: 'Alerts & posts' },
  { name: 'Analytics', href: '/analytics', icon: BarChart3, description: 'Platform analytics' },
  { name: 'Settings', href: '/settings', icon: Settings2, description: 'Platform settings' },
]

export default function CommandPalette({ open, onOpenChange }) {
  const [search, setSearch] = useState('')
  const navigate = useNavigate()
  const inputRef = useRef(null)

  useEffect(() => {
    if (open) {
      setSearch('')
      setTimeout(() => inputRef.current?.focus(), 50)
    }
  }, [open])

  const filtered = pages.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    p.description.toLowerCase().includes(search.toLowerCase())
  )

  const handleSelect = useCallback((href) => {
    onOpenChange(false)
    navigate(href)
  }, [navigate, onOpenChange])

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && filtered.length > 0) {
      handleSelect(filtered[0].href)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="overflow-hidden p-0 max-w-lg" hideClose>
        <Command>
          <CommandInput
            ref={inputRef}
            placeholder="Search pages..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <CommandList>
            {filtered.length === 0 && <CommandEmpty>No results found.</CommandEmpty>}
            <CommandGroup heading="Pages">
              {filtered.map((page) => (
                <CommandItem
                  key={page.href}
                  onClick={() => handleSelect(page.href)}
                  className="cursor-pointer"
                >
                  <page.icon className="mr-3 h-4 w-4 text-gray-400" />
                  <div>
                    <p className="text-sm font-medium text-gray-900">{page.name}</p>
                    <p className="text-xs text-gray-500">{page.description}</p>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  )
}
